import { getMark } from '@atlassian/jira-common-performance/src/marks.tsx';
import { SPA_SSR_RENDERED } from '@atlassian/jira-providers-spa-apdex-analytics/src/constants.tsx';

export const getSSRMark = () => getMark(SPA_SSR_RENDERED)?.startTime || null;
